import React from 'react';
import { string } from 'prop-types';
import { colors } from '@styleseat/brand';
import { BodyText } from '../../../ui';

export default function ErrorMessage({ message }) {
  return (message !== null) ? (
    <BodyText
      testID="error-text"
      appearance="small"
      weight="thin"
      color={colors.red}
    >
      {message}
    </BodyText>
  ) : null;
}

ErrorMessage.propTypes = {
  /** The message to display */
  message: string,
};

ErrorMessage.defaultProps = {
  message: null,
};
